const song1 = [
  ["Если уходите, то закройте дверь.", "If you're leaving close the door."],
  ["Я больше не жду людей.", "I'm not expecting people anymore."],
  [
    "Услышьте мое горе, я лежу на полу.",
    "Hear me grieving, I'm lying on the floor.",
  ],
  [
    "пьяный я или мертвый - точно не знаю.",
    "Whether I'm drunk or dead I really ain't too sure.",
  ],
  ["я слепой и мой мир тусклый.", "I'm blind man And my world is pale."],
  ["Когда слепой плачет.", "When a blind man cries,"],
  [
    "боже, ты знаешь нет печальнее рассказа.",
    "Lord, you know there ain't no sadder tale.",
  ],
  ["Однажды в комнате был друг.", "Had a friend once in a room,"],
  ["Мы хорошо провели время.", "Had a good time"],
  ["Но оно закончилось слишком быстро.", "But it ended much too soon."],
  ["В холодный месяц в этой комнате.", "In a cold month in that room"],
  [
    "Мы нашли причину того, что мы должны были сделать.",
    "We found a reason For the things we had to do.",
  ],
  [
    "Я слепой, теперь мой мир холодный.",
    "I'm blind man, Now my world is cold.",
  ],
  [
    "Ты знаешь, Боже, он переживает это душой.",
    "Lord, you know, he feels it from his soul.",
  ],
];

export default song1;
